// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1e9bm","requiredAsterisk":"Info_requiredAsterisk__3ZswG"};